/** Identify the signed-in admin user with LaunchDarkly (admin portal has no tenant context). */
export async function identifyAdminUserFromStorage(vueInstance) {
  if (!vueInstance?.$updateUser) {
    return;
  }
  try {
    const raw = localStorage.getItem("user");
    if (!raw) {
      return;
    }
    const user = JSON.parse(raw);
    await vueInstance.$updateUser({
      key: String(user.id ?? user.email ?? "anonymous-user"),
      email: user.email,
      name: `${user.first_name || ""} ${user.last_name || ""}`.trim() || user.email,
    });
  } catch {
    // LD identify is best-effort; flags fall back to defaults when it fails.
  }
}
